import Box from "@mui/material/Box";
import { enqueueSnackbar } from "notistack";
import { useState } from "react";
import TextField from "@mui/material/TextField";
import { Button } from "@mui/material";
import { APIRequestErrorInterface } from "../../../api/fetchApi";
import i18nStore from "../../../i18n/store";
import ProjectsApi from "../api";
import { CreateProjectInterface } from "../interfaces";
import projectStore from "../store";
import { observer } from "mobx-react-lite";
import FormHeader from "../../../components/FormHeader";
import Modal from "@mui/material/Modal";
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';


const style = {
    position: 'absolute',
    top: '30%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    minWidth: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};


const TestBuses: string[] = [
    "IEEE 5",
    "IEEE 14",
];


interface CreateProjectFormProps {
    openCreationModal: boolean;
    setOpenCreationModal: (openCreationModal: boolean) => void;
}
const CreateProjectForm = observer((props: CreateProjectFormProps) => {
    const translations = i18nStore.getTranslations;

    const [name, setName] = useState<string>("");
    const [description, setDescription] = useState<string>("");
    const [checked, setChecked] = useState<boolean>(false);
    const [testBus, setTestBus] = useState<string>(TestBuses[0]);

    return (
        <>
            <Modal
                open={props.openCreationModal}
                onClose={() => props.setOpenCreationModal(false)}
            >
                <Box sx={{ display: "flex", flexDirection: "column", ...style }}>
                    <FormHeader text={translations.newProject} />

                    <TextField
                        label={translations.name}
                        variant="outlined"
                        size="small"
                        value={name}
                        required
                        onChange={(e) => setName(e.target.value)}
                    />

                    <TextField
                        label={translations.description}
                        variant="outlined"
                        size="small"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        fullWidth
                        sx={{ mt: 2 }}
                    />

                    <FormGroup sx={{ mt: 2, }}>
                        <FormControlLabel
                            control={<Checkbox checked={checked} onChange={(event) => setChecked(event.target.checked)} />}
                            label={translations.createFromTestBus}
                        />
                    </FormGroup>

                    {
                        checked &&
                        <Box>
                            <FormControl fullWidth>
                                <Select
                                    value={testBus}
                                    onChange={(event) => setTestBus(event.target.value)}
                                    displayEmpty
                                    size="small"
                                >
                                    {
                                        TestBuses.map(testBus => (
                                            <MenuItem value={testBus} key={testBus}>{testBus}</MenuItem>
                                        ))
                                    }
                                </Select>
                            </FormControl>
                        </Box>
                    }
                    <Button
                        fullWidth
                        disabled={!name}
                        onClick={() => {
                            ProjectsApi.create({
                                title: name,
                                description: description,
                                test_bus: checked ? testBus : undefined,
                            } as CreateProjectInterface).then(() => {
                                projectStore.prefetchData();
                                setName("");
                                setDescription("");
                            })
                                .then(() => {
                                    props.setOpenCreationModal(false);
                                })
                                .catch((err: APIRequestErrorInterface) => {
                                    enqueueSnackbar(err.details.detail, {variant: "error"});
                                    return err;
                                });
                        }}
                        variant="contained"
                        sx={{mt: 3}}
                    >
                        {translations.create}
                    </Button>
                </Box>
            </Modal>
        </>
    );
});


export default CreateProjectForm;
